<template>
  <div class="form">
    <!-- This form from Monday (not OG Google ones) get a darkgrey overlay if you start to fill
    out something, switches page and then switches back or exit and comes back. This overlay has
    a reset/continue button that isn't in view if the form doesn't use scroll... -->
    <iframe
      src="https://forms.monday.com/forms/embed/949f1a1a0643aca2a1334a4ee3bf0af0?r=use1"
      width="650"
      height="700"
      frameborder="0"
      marginheight="0"
      marginwidth="0"
    >
      Loading…
    </iframe>
  </div>
</template>

<script>

export default {
  name: 'Form',
  components: {
  },
};
</script>


<style lang="stylus" scoped>
  @require '../style/colors'

  .form
    background-color: $secondary-color;
    padding: 4rem;
    text-align: center

  img
    width: 100%
    max-width: 58rem
    margin-bottom: 2rem
    border-radius: 0.8rem

  iframe
    display: block
    margin: 0 auto

  @media only screen and (max-width: 700px)
    iframe
      width: 100%

    img
      max-width: calc(100% - 4rem)
      margin-bottom: 1rem

</style>
